import * as React from "react";
import {match, Redirect, Switch} from "react-router";
import CreateContact from "../components/contacts/CreateContact";
import ContactsList from "../components/contacts/ContactsList";
import ContactDetails from "../components/contacts/ContactDetails";
import AdminRoute from "./route/AdminRoute";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 * Contact router view.
 */
export default class ContactRouter extends React.PureComponent <RouteProps, {}> {

	render() {
		return (
			<Switch>
				<AdminRoute exact
							path={this.props.match.url}
							component={ContactsList}/>
				<AdminRoute exact
							path={this.props.match.url + "/create"}
							component={CreateContact}/>
				<AdminRoute path={this.props.match.url + "/:contactId"}
							component={ContactDetails}/>
				<Redirect to={this.props.match.url}/>
			</Switch>
		)
	}

}